import api from "../axios/axiosInstance";

/**
 * Get all meetings for a contact
 * @param {Object} params
 * @param {string} params.contact_id - Contact ID (required)
 * @param {string} params.sortBy - Sort order: 'ascending' or 'descending' (optional)
 * @param {string} params.filterBy - Filter by type: 'online', 'offline', or 'all' (optional)
 * @param {string} params.category - Category ("contact" or "lead"), defaults to "contact"
 */
export const getMeetingsForContact = async (params) => {
  try {
    const paramsWithCategory = {
      ...params,
      category: params.category || "contact",
    };
    const response = await api.get("/meeting/getAll", {
      params: paramsWithCategory,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching meetings:", error);
    throw error;
  }
};

/**
 * Add or update a meeting for a contact
 * @param {Object} meetingData
 * @param {string} meetingData.contact_id - Contact ID (required)
 * @param {string} meetingData.meeting_id - Meeting ID (optional, for updates)
 * @param {string} meetingData.meetingTitle - Meeting title
 * @param {string} meetingData.meetingDescription - Meeting description
 * @param {string} meetingData.meetingStartDate - Meeting start date (ISO string)
 * @param {string} meetingData.meetingStartTime - Meeting start time (HH:mm:ss format)
 * @param {string} meetingData.meetingType - Meeting type: 'online' or 'offline'
 * @param {string} meetingData.meetingLocation - Meeting location (for offline meetings)
 * @param {string} meetingData.timezone - Timezone (default: 'UTC')
 * @param {string} meetingData.category - Category ("contact" or "lead"), defaults to "contact"
 */
export const addOrUpdateMeeting = async (meetingData) => {
  try {
    const dataWithCategory = {
      ...meetingData,
      category: meetingData.category || "contact",
    };
    const response = await api.post(
      "/meeting/addUpdateMeeting",
      dataWithCategory
    );
    return response.data;
  } catch (error) {
    console.error("Error adding/updating meeting:", error);
    throw error;
  }
};

/**
 * Delete a meeting from a contact
 * @param {Object} params
 * @param {string} params.contact_id - Contact ID (required)
 * @param {string} params.meeting_id - Meeting ID (required)
 * @param {string} params.category - Category ("contact" or "lead"), defaults to "contact"
 */
export const deleteMeeting = async (params) => {
  try {
    const paramsWithCategory = {
      ...params,
      category: params.category || "contact",
    };
    const response = await api.delete("/meeting/deleteMeeting", {
      data: paramsWithCategory,
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting meeting:", error);
    throw error;
  }
};
